<template>
  <div id="app">
    <!-- Main content container -->
    <div id="main-content">
      <router-view></router-view>
    </div>

    <!-- Overlay container (modals, sidebars) -->
    <div id="overlay-layer">
      <OverlayContainer />
    </div>
  </div>
</template>

<script>
import OverlayContainer from '@/components/overlays/OverlayContainer.vue';

export default {
  name: 'App',
  components: {
    OverlayContainer
  }
}
</script>
